(function() {
  var BaseLayer,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  BaseLayer = App.loadClass("grower::viewmodels/prescription_map/Layer");

  exports.Layer = (function(superClass) {
    extend(Layer, superClass);

    function Layer(parent, data, deps) {
      var i, ref, ref1, ref10, ref11, ref12, ref13, ref14, ref15, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, results;
      if (data == null) {
        data = {};
      }
      if (deps == null) {
        deps = {};
      }
      Layer.__super__.constructor.call(this, parent, data, deps);
      this.setInitialDeps();
      this.syncDeps(deps);
      this.ignore(['num_pop_options', 'min_pop_diff_options', 'max_pop_diff_options', 'calculated_pop']);
      this.hybrid_id = (ref = (ref1 = data.prescription_map) != null ? ref1.hybrids_id : void 0) != null ? ref : 634;
      this.machinery_id = ko.observable((ref2 = data.prescription_map) != null ? ref2.machinery_planters_id : void 0);
      this.target_population = ko.observable((ref3 = (ref4 = data.prescription_map) != null ? ref4.target_population : void 0) != null ? ref3 : 0);
      this.min_population = ko.observable((ref5 = (ref6 = data.prescription_map) != null ? ref6.minimum_population : void 0) != null ? ref5 : null);
      this.max_population = ko.observable((ref7 = (ref8 = data.prescription_map) != null ? ref8.maximum_population : void 0) != null ? ref7 : null);
      this.target_population.subscribe((function(_this) {
        return function(tval) {
          var t;
          if (tval.toString().indexOf(',') !== -1) {
            t = parseInt(tval.toString().replace(',', ''));
            return _this.target_population(t);
          }
        };
      })(this));
      this.min_population.subscribe((function(_this) {
        return function(min) {
          var t;
          if (min.toString().indexOf(',') !== -1) {
            t = parseInt(min.toString().replace(',', ''));
            return _this.min_population(t);
          }
        };
      })(this));
      this.max_population.subscribe((function(_this) {
        return function(max) {
          var t;
          if (max.toString().indexOf(',') !== -1) {
            t = parseInt(max.toString().replace(',', ''));
            return _this.max_population(t);
          }
        };
      })(this));
      this.num_populations = ko.observable((ref9 = (ref10 = data.prescription_map) != null ? ref10.max_number_of_populations : void 0) != null ? ref9 : 3);
      this.min_pop_diff = ko.observable((ref11 = (ref12 = data.prescription_map) != null ? ref12.min_population_difference : void 0) != null ? ref11 : 1000);
      this.max_pop_diff = ko.observable((ref13 = (ref14 = data.prescription_map) != null ? ref14.max_population_difference : void 0) != null ? ref13 : 1500);
      this.was_recalculated = ko.observable(true);
      this.num_pop_options = (function() {
        results = [];
        for (i = 1; i <= 30; i++){ results.push(i); }
        return results;
      }).apply(this);
      this.min_pop_diff_options = [100, 500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000];
      this.max_pop_diff_options = [100, 500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000];
      this.planters = (ref15 = data.planters) != null ? ref15 : [];
      this.controller = ko.computed((function(_this) {
        return function() {
          var con_make, con_mod, j, k, len, mach, ref16;
          mach = null;
          ref16 = _this.planters;
          for (j = 0, len = ref16.length; j < len; j++) {
            k = ref16[j];
            if (k.id === _this.machinery_id()) {
              mach = k;
              break;
            }
          }
          if (mach != null) {
            con_mod = mach.controller_model.name;
            con_make = mach.controller_model.make.name;
            return con_mod + " - " + con_make;
          }
          return '';
        };
      })(this));
      this.calculated_pop = ko.computed((function(_this) {
        return function() {
          var averaging, j, k, len, mypop, ref16;
          averaging = 0;
          ref16 = _this.stages;
          for (j = 0, len = ref16.length; j < len; j++) {
            k = ref16[j];
            mypop = parseFloat(k.field_soil_acres) * parseFloat(k.population());
            averaging += mypop;
          }
          if ((averaging != null) && (_this.total_acres() != null)) {
            return parseInt(averaging / _this.total_acres());
          }
          return 0;
        };
      })(this));

      /*
      Fun tricks for deciding if the recalculate
      button should be switched to green to indicate
      something has changed and recalculation is necessary.
      
      Basically, KO detects dependencies for computed by
      keeping track of which observables were read from during
      the computed's calculation. So we just read from all the
      variables that will cause the button to change to green when updated,
      forcing those variables to be tracked as dependencies of this
      computed.
       */
      this.update_button = ko.computed((function(_this) {
        return function() {
          _this.machinery_id();
          _this.target_population();
          _this.min_population();
          _this.max_population();
          _this.num_populations();
          _this.min_pop_diff();
          _this.max_pop_diff();
          if (_this.was_recalculated()) {
            _this.was_recalculated(false);
            return 'btn span12 rx_map-recalc_btn';
          }
          return 'btn btn-primary span12 rx_map-recalc_btn';
        };
      })(this));
    }

    return Layer;

  })(BaseLayer);

}).call(this);
